import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Table, Icon, Spin } from 'antd';
import { TitleText, BasicText, ShortInput, LongInput, CopyUrl, BasicButton } from '@components';
import { ConfirmModal } from '@components';
import { blockUser, unblockUser } from '@actions';

const BlockButton = ({
  user,
  blockUser,
  unblockUser,
  recentlyBlockedId,
  recentlyUnblockedId
}) => {
  const [isBlocked, setIsBlocked] = useState(user.is_blocked);
  const [blockConfirm, setBlockConfirm] = useState(false);
  const [unBlockConfirm, setUnBlockConfirm] = useState(false);
  const [blockLoading, setBlockLoading] = useState(false);

  useEffect(() => {
    if (recentlyBlockedId === user.id) {
      setIsBlocked(true);
    } else if (recentlyUnblockedId === user.id) {
      setIsBlocked(false);
    }
  }, [recentlyBlockedId, recentlyUnblockedId]);


  const blockUserConfirmed = () => {
    setBlockLoading(true);
    console.log("blocking", user.full_name);
    blockUser(user.id, () => {
      setBlockLoading(false);
      setBlockConfirm(false);
    }, () => setBlockLoading(false));

  };

  const unBlockUserConfirmed = () => {
    console.log("unblocking", user.full_name);
    unblockUser(user.id, () => {
      setUnBlockConfirm(false);
      setBlockLoading(false);
    }, () => setBlockLoading(false));
  };

  const button = () => {
    if (isBlocked) {
      return (
        <BasicButton
          text="Unblock"
          type="default"
          fontSize={10}
          style={{ padding: 8 }}
          onClick={() => setUnBlockConfirm(true)}
        />
      );
    } else {
      return (
        <BasicButton
          text="Block"
          type="danger"
          fontSize={10}
          style={{ padding: 8 }}
          onClick={() => setBlockConfirm(true)}
        />
      );
    }
  }

  return (
    <>
      {button()}

      {blockConfirm &&
        <ConfirmModal
          title={"Confirm Block User"}
          visible={blockConfirm}
          loading={blockLoading}
          onCancel={() => setBlockConfirm(false)}
          onSubmit={() => blockUserConfirmed()}
        >
          <BasicText marginBottom="20px">
            Are you sure you want to block the user {user.full_name}?
          </BasicText>
        </ConfirmModal>
      }

      {unBlockConfirm &&
        <ConfirmModal
          title={"Confirm Block User"}
          visible={unBlockConfirm}
          loading={blockLoading}
          onCancel={() => setUnBlockConfirm(false)}
          onSubmit={() => unBlockUserConfirmed()}
        >
          <BasicText marginBottom="20px">
            Are you sure you want to unblock the user {user.full_name}?
          </BasicText>
        </ConfirmModal>
      }
    </>
  );
};

const mapStatesToProps = (state) => {
  const { recentlyBlockedId, recentlyUnblockedId } = state.admin;
  return { recentlyBlockedId, recentlyUnblockedId };
};

export default connect(mapStatesToProps, {
  blockUser,
  unblockUser
})(BlockButton);
